import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportedSapComponent } from './imported-sap.component';


const routes: Routes = [
  {
    path: '',
    component: ImportedSapComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImportedSapRoutingModule { }
